
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ritual-praxis",
      function () {
        return require("private-next-pages/ritual-praxis/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ritual-praxis"])
      });
    }
  